import React from 'react';
import styled, { css } from 'styled-components';
import SearchIcon from 'assets/icons/searchArrow.svg';

const SearchHeaderContainer = styled.div`
  width: 100%;
  border-bottom: 1px solid #d7d6e0;
  min-height: 47px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const SearchArrow = styled.span`
  display: inline-block;
  position: absolute;
  left: ${({ left }) => left};
  right: ${({ right }) => right};
  top: 50%;
  width: 10px;
  height: 17px;
  background-image: url(${({ background }) => background});
  background-position: center;
  background-repeat: no-repeat;
  transform: translateY(-50%);
`;

const SearchHeaderData = styled.p`
  color: ${({ color }) => color || '#000000'};
  margin: ${({ margin }) => margin};
`;

const CrossSVG = () => <i className="fas fa-times" />;

const SearchHeader = ({ region, date, onBackClick, redirectOnMainPage }) => {
  return (
    <SearchHeaderContainer>
      <SearchArrow background={SearchIcon} left="0" onClick={onBackClick} />
      {region && (
        <SearchHeaderData margin="0" color="#9791A7">
          {region}
        </SearchHeaderData>
      )}
      {date && (
        <SearchHeaderData margin="0" color="#9791A7">{`${
          date.checkinDate ? date.checkinDate : '...'
        }${' — '}${
          date.checkoutDate ? date.checkoutDate : '...'
        }`}</SearchHeaderData>
      )}
      <SearchArrow onClick={redirectOnMainPage} background="none" right="0">
        <CrossSVG />
      </SearchArrow>
    </SearchHeaderContainer>
  );
};

export default SearchHeader;
